import { clsx } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs) {
  return twMerge(clsx(inputs));
}

export function getOptimizedImageUrl(url, { width = 800, quality = 80, height } = {}) {
  if (!url || typeof url !== 'string') return url || '';
  if (!url.startsWith('https://assets.auxodev.dk') || url.includes('/cdn-cgi/image/')) {
    return url;
  }
  const params = [`width=${width}`, `quality=${quality}`, 'format=auto'];
  if (height) {
    params.push(`height=${height}`, 'fit=cover');
  }
  return url.replace(
    'https://assets.auxodev.dk/',
    `https://assets.auxodev.dk/cdn-cgi/image/${params.join(',')}/`
  );
}
